import { useState } from "react"
import { Button, Card, Col, FormControl, InputGroup, Row } from "react-bootstrap"
import ReactGoogleAutocomplete from "react-google-autocomplete"
import { FaAngleRight, FaBox, FaBoxOpen, FaPlusCircle, FaRegEnvelope } from "react-icons/fa"
import { maps_key, tipos_direccion } from "../../../lib/backend/data"
import { FaWeightScale } from "react-icons/fa6"
import { CiRuler } from "react-icons/ci"
import ModalProductos from "../../productos/modal_productos"
import { toast } from "react-toastify"
import { calcularPesoVolumetrico } from "../../../lib/helpers/pedidos/pedidos"
import { MdOutlinePlace } from 'react-icons/md';
import SelectorBodega from "../../bodega/bodegas/selector_bodega"
import { obtenerGeoDatosGoogle } from '../../../lib/helpers/pedidos/pedidos';
import Form from 'react-bootstrap/Form';
import { FiBox } from "react-icons/fi"



const BoxOrdenImportacion = (props) => {
    const {
        order,
        typeForm
    } = props
    const [ pedido, setPedido ] = useState(order)
    
    const producto_default = {
        description: "",
        codigo_item: "",
        quantity: "",
        price: "",
        ancho: "",
        alto: "",
        largo: "",
        peso: "",
    }
    
    if(!pedido) return false

    
    const eliminarProducto = (i) => {
        return setPedido(prev => {
            let actual = {...prev}
            actual.productos.splice(i,1)
            if(props.onChange) props.onChange(actual)
            return {...{}, ...actual}
        })
    }
    const handleChangeProducto = (e,i) => {
        const { name, value } = e.target
        return setPedido(prev => {
            let actual = {...prev}
            actual.productos[i][name] = value
            if(props.onChange) props.onChange(actual)
            return {...{}, ...actual}
        })
    }
    
    const agregarProducto = (nuevo) => {

        return setPedido(prev => {
            let actual = {...prev}
            if(!actual.productos) actual.productos = []
            const producto_nuevo = nuevo ? nuevo : producto_default
            if(producto_nuevo.codigo_item){
                const i = actual.productos.findIndex(p => p.codigo_item === producto_nuevo.codigo_item)
                if(i > -1 ){
                    toast.error("Producto ya existe")
                } else {
                    actual.productos.unshift(producto_nuevo)
                }
            } else {
                actual.productos.unshift(producto_nuevo)
            }
            if(props.onChange) props.onChange(actual)
            return {...{}, ...actual}
        })
    }
    
    const handleChange = (e,i) => {
        const { name, value } = e.target
        return setPedido(prev => {
            let actual = {...prev}
            actual[name] = value
            if(props.onChange) props.onChange(actual)
            return {...{}, ...actual}
        })
    }

    const handleChangeOrigen = (data) => {
        if(props.onChangeOrigen) props.onChangeOrigen(data)
        const geo_informacion = obtenerGeoDatosGoogle(data ? data.geodata : {} )

        pedido.orden = {}
        

            let importar_datos = {
                level1: geo_informacion.level1 ?  geo_informacion.level1 : "",
                level2: geo_informacion.level2 ?  geo_informacion.level2 : "",
                pais: geo_informacion.pais ? geo_informacion.pais : "",
                level3: geo_informacion.level3 ? geo_informacion.level3 : "",
                address_1: data.direccion ? data.direccion : "",
            }

            let origen_datos = {
                address_1: data.direccion ? data.direccion : "",
                first_name: data.titulo ? data.titulo : "",
                ...geo_informacion
            }
            
            if(typeof data._id === "string"){
                importar_datos = {
                    ...importar_datos,
                    _id: data._id, 
                    tipo_lugar: "bodega",
                    first_name: data.titulo ? data.titulo : ""
                } 
            }

            if(data.location){
                if(typeof data.location === "object"){
                    if(data.location.coordinates){
                        if(data.location.coordinates.length > 1){
                            pedido.location = data.location
                            importar_datos.lat = data.location.coordinates[1]
                            importar_datos.lng = data.location.coordinates[0]
                        }
                    }
                }
                
            } 
        
        return setPedido(prev => {
            let actual = {...prev}
            actual.geo_datos_origen = importar_datos
            actual.origen = origen_datos
            if(props.onChange) props.onChange(actual)
            return actual
        })                         
    }

    const formularioAvanzadoProducto = () => {
        if(!pedido) return false
        if(!pedido.productos) return false
        if(!Array.isArray(pedido.productos)) return false

        return <div>
            <hr />
            <h5><FaBox /> {pedido.productos.length} Productos</h5>
            <Button size="sm" className="mb-3" variant="light" onClick={() => agregarProducto()}><FaPlusCircle /> AÑADIR NUEVO</Button>
            <ModalProductos onSelected={(data) => agregarProducto(data)} />
            {
                pedido.productos.map((producto,i) => {
                    return <div key={`pe-${pedido.referencia}-prod-${i}`}>
                        <Card  className="shadow mb-3">
                            <div className="p-3">
                            <Row>
                            {/* <Col className="mb-3" md={12}>
                                <label className="form-control-label d-block">Descripción</label>
                                <input className="form-control shadow-sm"   name="description"  onChange={(e) => handleChangeProducto(e,i)}     value={producto.description} /></Col> */}
                            {/* <Col className="mb-3" md={4}>
                                <label className="form-control-label d-block">Código producto</label>
                                <input className="form-control shadow-sm"   name="codigo_item"  onChange={(e) => handleChangeProducto(e,i)}     value={producto.codigo_item} /></Col> */}
                            <Col md={4}>
                                <h4 className="mb-0" style={{ fontWeight: 700 }}>Descripción</h4>
                                <Row>
                                    <Col className="mb-3" md={4}>
                                        <label className="form-control-label d-block">Tipo de bulto</label>
                                        <select className="form-control d-block">
                                            <option value="caja">Caja</option>
                                            <option value="sobre">Sobre</option>
                                            <option value="paquete">Paquete</option>
                                            <option value="otro">Otro</option>
                                        </select>
                                    </Col>
                                    <Col className="mb-3" md={4}>
                                        <label className="form-control-label d-block">Valor</label>
                                        <input className="form-control shadow-sm"   name="precio"     onChange={(e) => handleChangeProducto(e,i)}     type="number" value={producto.precio} />
                                    </Col>
                                    <Col className="mb-3" md={4}>
                                        <label className="form-control-label d-block">Cantidad</label>
                                        <input className="form-control shadow-sm"   name="quantity"     onChange={(e) => handleChangeProducto(e,i)}     type="number" value={producto.quantity} />
                                    </Col>
                                </Row>
                            </Col>
                            {/* <Col className="mb-3" md={4}>
                                <label className="form-control-label d-block">Precio</label>
                                <input className="form-control shadow-sm"   name="price"        onChange={(e) => handleChangeProducto(e,i)}     type="number" value={producto.price} /></Col> */}
                            <Col md={6}>
                                <h4 className="mb-0" style={{ fontWeight: 700 }}>Tamaño</h4>
                                <Row>
                                <Col className="mb-3" md={4}>
                                <label className="form-control-label d-block">Ancho</label>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                    <InputGroup.Text>CM</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <FormControl name="ancho" onChange={(e) => handleChangeProducto(e,i)}     type="number" value={producto.ancho} />
                                </InputGroup>
                            </Col>
                            <Col className="mb-3" md={4}>
                                <label className="form-control-label d-block">Alto</label>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                    <InputGroup.Text>CM</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <FormControl name="alto" onChange={(e) => handleChangeProducto(e,i)}     type="number" value={producto.alto} />
                                </InputGroup>
                            </Col>
                            <Col className="mb-3" md={4}>
                                <label className="form-control-label d-block">Largo</label>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                    <InputGroup.Text>CM</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <FormControl name="largo" onChange={(e) => handleChangeProducto(e,i)}     type="number" value={producto.largo} />
                                </InputGroup>
                            </Col>
                                </Row>
                            </Col>
                            <Col md={2}>
                                <h4 className="mb-0" style={{ fontWeight: 700 }}>Peso</h4>
                                <label className="form-control-label d-block">Peso</label>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                    <InputGroup.Text>KG</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <FormControl name="peso" onChange={(e) => handleChangeProducto(e,i)}   type="number" value={producto.peso} />
                                </InputGroup>
                            </Col>
                            
                        </Row>
                            {pedido.productos.length > 1 ? <Button size="sm" variant="link" className="text-danger" onClick={() => eliminarProducto(i)} >ELIMINAR</Button> : false }
                            </div>
                        </Card>
                        
                    </div>
                })
            }
        </div>
    }

    const mostrarEmailsAdicionales = () => {
        if(!pedido) return false
        if(!pedido.emails_adicionales) return false
        if(!Array.isArray(pedido.emails_adicionales)) return false

        return <div>
            <hr />
            <h5 style={{fontWeight:700}}><FaRegEnvelope style={{ verticalAlign: "middle"}} /> Notificaciones ({pedido.emails_adicionales.length} {pedido.emails_adicionales.length === 1 ? 'Email' : 'Emails'})</h5>
            {
                pedido.emails_adicionales.map((email,i) => <p className="mb-1" key={`${pedido.referencia}-${i}`}><FaAngleRight style={{ verticalAlign: "middle"}} /> {email}</p>)
            }
        </div>
    }

    const mostrarProductos = () => {
        if(!pedido) return false
        if(!pedido.productos) return false
        if(!Array.isArray(pedido.productos)) return false

        if(typeForm === "advance"){
            return formularioAvanzadoProducto()
        }

        return <div>
            <hr />
            <h5 style={{fontWeight:700}}><FaBoxOpen style={{ verticalAlign: "middle"}} /> Detalle de la carga ({pedido.productos.length} {pedido.productos.length === 1 ? 'Producto' : 'Productos'})</h5>
            <Button size="sm" className="mb-3" variant="light" onClick={() => agregarProducto()}><FaPlusCircle /> AÑADIR NUEVO</Button>
            {/* <ModalProductos onSelected={(data) => agregarProducto(data)} /> */}
            {
                pedido.productos.map((producto,i) => {
                    return <div key={`pe-${pedido.referencia}-prod-${i}`}>
                        {/* <Card className=" mb-3"> */}
                            <div className="pt-2">
                            <Row>
                            {/* <Col className="mb-3" md={12}>
                                <label className="form-control-label d-block">Descripción</label>
                                <input className="form-control shadow-sm"   name="description"  onChange={(e) => handleChangeProducto(e,i)}     value={producto.description} /></Col>
                            <Col className="mb-3" md={4}>
                                <label className="form-control-label d-block">Código producto</label>
                                <input className="form-control shadow-sm"   name="codigo_item"  onChange={(e) => handleChangeProducto(e,i)}     value={producto.codigo_item} /></Col>
                            <Col className="mb-3" md={4}>
                                <label className="form-control-label d-block">Cantidad</label>
                                <input className="form-control shadow-sm"   name="quantity"     onChange={(e) => handleChangeProducto(e,i)}     type="number" value={producto.quantity} /></Col>
                            <Col className="mb-3" md={4}>
                                <label className="form-control-label d-block">Precio</label>
                                <input className="form-control shadow-sm"   name="price"        onChange={(e) => handleChangeProducto(e,i)}     type="number" value={producto.price} /></Col> */}
                            <Col md={8}>
                                <h6 className="my-2" style={{fontWeight:700}}><i className="fa-solid fa-up-right-and-down-left-from-center"></i> Tamaño</h6>
                                <Row>
                                <Col className="mb-3" md={4}>
                                {/* <label className="form-control-label d-block">Ancho</label> */}
                                <InputGroup size="sm" className="mb-3">
                                <InputGroup.Prepend>
                                    <InputGroup.Text style={{ fontSize: 11 }} >Ancho</InputGroup.Text>
                                </InputGroup.Prepend>
                                    <Form.Control name="ancho" onChange={(e) => handleChangeProducto(e,i)}     type="number" value={producto.ancho}  />
                                <InputGroup.Prepend>    
                                    <InputGroup.Text style={{ fontSize: 11 }} >cm</InputGroup.Text>
                                </InputGroup.Prepend>
                                </InputGroup>
                            </Col>
                            <Col className="mb-3" md={4}>
                                {/* <label className="form-control-label d-block">Alto</label> */}
                                <InputGroup size="sm" className="mb-3 mx-0">
                                <InputGroup.Prepend>
                                    <InputGroup.Text style={{ fontSize: 11 }} >Alto</InputGroup.Text>
                                </InputGroup.Prepend>
                                    <Form.Control name="alto" onChange={(e) => handleChangeProducto(e,i)}     type="number" value={producto.alto} />
                                <InputGroup.Prepend>    
                                    <InputGroup.Text style={{ fontSize: 11 }} >cm</InputGroup.Text>
                                </InputGroup.Prepend>
                                </InputGroup>
                                {/* <InputGroup>
                                    <InputGroup.Prepend>
                                    <InputGroup.Text>CM</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <FormControl name="alto" onChange={(e) => handleChangeProducto(e,i)}     type="number" value={producto.alto} />
                                </InputGroup> */}
                            </Col>
                            <Col className="mb-3" md={4}>
                                {/* <label className="form-control-label d-block">Largo</label> */}
                                <InputGroup size="sm" className="mb-3">
                                <InputGroup.Prepend>
                                    <InputGroup.Text style={{ fontSize: 11 }} >Largo</InputGroup.Text>
                                </InputGroup.Prepend>
                                    <Form.Control name="largo" onChange={(e) => handleChangeProducto(e,i)}     type="number" value={producto.largo}  />
                                <InputGroup.Prepend>    
                                    <InputGroup.Text style={{ fontSize: 11 }} >cm</InputGroup.Text>
                                </InputGroup.Prepend>
                                </InputGroup>
                            </Col>
                                </Row>
                            </Col>
                            <Col md={2}>
                                <h6 className="my-2" style={{fontWeight:700}}><FiBox /> Cantidad</h6>
                                <InputGroup size="sm" className="mb-3">
                                    <Form.Control name="quantity" onChange={(e) => handleChangeProducto(e,i)}   type="number" value={producto.quantity} />
                                </InputGroup>
                            </Col>
                            <Col md={2}>
                                <h6 className="my-2" style={{fontWeight:700}}><i className="fa-solid fa-weight-hanging"></i> Peso</h6>
                                {/* <label className="form-control-label d-block">Peso</label> */}
                                <InputGroup size="sm" className="mb-3">
                                {/* <InputGroup.Prepend>
                                    <InputGroup.Text>Peso</InputGroup.Text>
                                </InputGroup.Prepend> */}
                                    <Form.Control name="peso" onChange={(e) => handleChangeProducto(e,i)}   type="number" value={producto.peso} />
                                <InputGroup.Prepend>    
                                    <InputGroup.Text style={{ fontSize: 11 }}>Kg</InputGroup.Text>
                                </InputGroup.Prepend>
                                </InputGroup>
                            </Col>
                            
                        </Row>
                            {pedido.productos.length > 1 ? <Button size="sm" variant="link" className="text-danger" onClick={() => eliminarProducto(i)} >ELIMINAR</Button> : false }
                            </div>                        
                    </div>
                })
            }
        </div>
    }

    const formularioAvanzado = () => {
        return <div>
            <Row>
                <Col md={3} className="mb-3">
                    <label className="form-control-label d-block" style={{fontWeight:700}}>Referencia</label>
                    <input className="form-control" name="referencia" value={pedido.referencia} onChange={handleChange} />
                </Col>
                <Col md={3} className="mb-3">
                    <label className="form-control-label d-block" style={{fontWeight:700}}>Destinatario</label>
                    <input className="form-control" name="nombre_contacto" value={pedido.nombre_contacto} onChange={handleChange} />
                </Col>
                <Col md={3} className="mb-3">
                    <label className="form-control-label d-block" style={{fontWeight:700}}>Móvil</label>
                    <input className="form-control" name="telefono" value={pedido.telefono} onChange={handleChange} />
                </Col>
                <Col md={3} className="mb-3">
                    <label className="form-control-label d-block" style={{fontWeight:700}}>Email</label>
                    <input className="form-control" name="email_contacto" value={pedido.email_contacto} onChange={handleChange} />
                </Col>
                <Col md={8}>
                <label className="form-control-label d-block" style={{fontWeight:700}}>Dirección</label>
                <ReactGoogleAutocomplete
                        className="form-control"
                        defaultValue={pedido.direccion}
                        options={{
                            types: tipos_direccion,
                            // cokmponentRestrictions: { country: pais },
                        }}                    
                        apiKey={maps_key}
                        onPlaceSelected={(informacion) => {
                            if(!informacion) return false
                            const lat = informacion.geometry.location.lat()
                            const lng = informacion.geometry.location.lng()

                            let pais = ''
                            let codigo_pais = ''
                            let level1 = ''
                            let level2 = ''
                            let level3 = ''

                            let formatted_address = ''
            
                            if(informacion.formatted_address){
                                formatted_address = informacion.formatted_address
                            }
            
                            const i_pais = informacion.address_components.findIndex(a => a.types.includes('country'))
                            if(i_pais > -1){
                                pais = informacion.address_components[i_pais].long_name
                                codigo_pais = informacion.address_components[i_pais].short_name
                            }
            
                            const l1 = informacion.address_components.findIndex(a => a.types.includes('administrative_area_level_1'))
                            if(l1 > -1) level1 = informacion.address_components[l1].long_name
                            
                            const l2 = informacion.address_components.findIndex(a => a.types.includes('administrative_area_level_2'))
                            if(l2 > -1) level2 = informacion.address_components[l2].long_name
                            
                            const l3 = informacion.address_components.findIndex(a => a.types.includes('administrative_area_level_3'))
                            if(l3 > -1) level3 = informacion.address_components[l3].long_name

                            
                            let location = {
                                type: "Point",
                                coordinates: [
                                    lng, lat
                                ]
                            }

                            const geo_datos = {
                                pais,
                                codigo_pais,
                                formatted_address,
                                level1,
                                level2,
                                level3,
                                lat,
                                lng
                            }
                            
                            return setPedido(prev => {
                                let actual = {...prev}
                                actual.direccion = informacion.formatted_address
                                actual.geo_datos = geo_datos
                                actual.location = location
                                if(props.onChange) props.onChange(actual)
                                return actual
                            })                         
                        }}
                        />
                </Col>
                <Col md={4}>
                    <label className="form-control-label d-block" style={{fontWeight:700}}>Observaciones de la dirección</label>
                    <input className="form-control" name="observaciones_direccion" value={pedido.observaciones_direccion} onChange={handleChange} />
                </Col>
            </Row>
            {mostrarProductos()}
            {mostrarEmailsAdicionales()}
        </div>
    }

    if(typeForm === "advance"){
        return formularioAvanzado()
    }

    return <div className="text-primary">
            <Row>
            <Col xs={6}>
                <Row>
                <Col md={3} className='pr-0'><h5 className='d-block' style={{fontWeight:900}}><MdOutlinePlace size={25} /> Origen</h5></Col>
                <Col md={9} className='pl-0'><hr/></Col>
                <Col md={12}><SelectorBodega defaultValue={pedido.origen_direccion_excel} onChange={(data) => handleChangeOrigen(data)} /></Col>
                </Row>
            </Col>
            <Col xs={6}>
                <Row>
                    <Col md={3} className='pr-0'><h5 className='d-block' style={{fontWeight:900}}><MdOutlinePlace size={25} /> Destino</h5></Col>
                    <Col md={9} className='pl-0'><hr/></Col>
                    <Col md={12}>
                <label className="form-control-label d-block" style={{fontWeight:700}}>Dirección</label>
                <ReactGoogleAutocomplete
                        className="form-control"
                        defaultValue={pedido.direccion}
                        options={{
                            types: tipos_direccion,
                            // cokmponentRestrictions: { country: pais },
                        }}                    
                        apiKey={maps_key}
                        onPlaceSelected={(informacion) => {
                            if(!informacion) return false
                            const lat = informacion.geometry.location.lat()
                            const lng = informacion.geometry.location.lng()

                            let pais = ''
                            let codigo_pais = ''
                            let level1 = ''
                            let level2 = ''
                            let level3 = ''

                            let formatted_address = ''
            
                            if(informacion.formatted_address){
                                formatted_address = informacion.formatted_address
                            }
            
                            const i_pais = informacion.address_components.findIndex(a => a.types.includes('country'))
                            if(i_pais > -1){
                                pais = informacion.address_components[i_pais].long_name
                                codigo_pais = informacion.address_components[i_pais].short_name
                            }
            
                            const l1 = informacion.address_components.findIndex(a => a.types.includes('administrative_area_level_1'))
                            if(l1 > -1) level1 = informacion.address_components[l1].long_name
                            
                            const l2 = informacion.address_components.findIndex(a => a.types.includes('administrative_area_level_2'))
                            if(l2 > -1) level2 = informacion.address_components[l2].long_name
                            
                            const l3 = informacion.address_components.findIndex(a => a.types.includes('administrative_area_level_3'))
                            if(l3 > -1) level3 = informacion.address_components[l3].long_name

                            
                            let location = {
                                type: "Point",
                                coordinates: [
                                    lng, lat
                                ]
                            }

                            const geo_datos = {
                                pais,
                                codigo_pais,
                                formatted_address,
                                level1,
                                level2,
                                level3,
                                lat,
                                lng
                            }
                            
                            return setPedido(prev => {
                                let actual = {...prev}
                                actual.direccion = informacion.formatted_address
                                actual.geo_datos = geo_datos
                                actual.location = location
                                if(props.onChange) props.onChange(actual)
                                return actual
                            })                         
                        }}
                        />
                </Col>
                </Row>
            </Col>
                {/* <Col md={4}>
                    <label className="form-control-label d-block" style={{fontWeight:700}}>Destinatario</label>
                    <input className="form-control" name="nombre_contacto" value={pedido.nombre_contacto} onChange={handleChange} />
                </Col> */}
                
            </Row>            
            {mostrarProductos()}
            {mostrarEmailsAdicionales()}
    </div>
}

export default BoxOrdenImportacion